<template>
  <div v-bind="result.attributes" class="slider-card" @click="handlerClickGoogle">
    <a :href="result.detailPage" class="slider-card__link">
      <DefLabels :result="result.labels" />
      <DefImg v-if="result.picture" :result="result.picture" />
      <GiaPhoto v-if="result.isGia" />
    </a>
    <div class="slider-card__block">
      <DefColorsSmall :result="result" />
      <span v-if="result.printDiscountPercent" class="slider-card__discount">{{
        result.printDiscountPercent
      }}</span>
      <a :href="result.detailPage" class="slider-card__name">{{ result.name }}</a>
      <div v-if="result.price && result.price.printPrice" class="slider-card-prices">
        <DefPrice>{{ result.price.printPrice }}</DefPrice>
        <DefPriceOld v-if="+result.price.printPrice !== +result.price.printPriceOld">{{
          result.price.printPriceOld
        }}</DefPriceOld>
      </div>
    </div>
  </div>
</template>

<script>
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import Analytics from '@/utils/Analytics';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';

export default {
  name: 'SliderCard',
  components: { DefLabels, DefColorsSmall, DefPrice, DefPriceOld, GiaPhoto, DefImg },
  props: {
    result: {
      type: Object,
    },
    messages: {
      type: Object,
      default: () => ({
        detail: 'Детальнее',
      }),
    },
    changeData: {
      type: [Function, Object],
    },
  },
  methods: {
    handlerClickGoogle() {
      Analytics.clickOnProduct(this.result);
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-card {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  font-weight: 500;
  color: #191918;
  font-size: rem(14);
  letter-spacing: 0.08em;
  position: relative;
  height: 100%;
  @include point-md {
    font-size: rem(16);
  }

  &__discount {
    display: block;
    color: var(--discount-color);
    margin-bottom: 4px;
    font-size: rem(10);
    letter-spacing: 0.1em;
    height: 12px;
    @include point-md {
      font-size: rem(12);
    }
  }

  &__name {
    display: block;
    margin-bottom: 12px;
    font-size: 14px;
    letter-spacing: 1.12px;
    @include point-md {
      margin-bottom: 16px;
    }
    @include point-lg {
      font-size: 16px;
      letter-spacing: 1.12px;
    }
  }

  &__block {
    padding: 8px;
    @include point-md {
      padding: 16px;
    }
    @include point-lg {
      padding: 12px 24px 24px;
    }
    :deep(.def-colors-small) {
      margin-bottom: 16px;
    }
  }

  &__view {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    background: var(--background-colour-primary);
    font-weight: 500;
    font-size: rem(14);
    text-transform: uppercase;
    color: #467496;
    opacity: 0;
    transition: 0.3s linear opacity;

    &:hover {
      cursor: pointer;
    }
  }

  &:hover {
    .slider-card__view {
      opacity: 1;
    }
  }

  .def-like {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  &__link {
    position: relative;

    padding: 12px 8px;
    @include point-md {
      padding: 16px 24px;
    }
    @include point-lg {
      padding: 24px;
    }
  }

  &__wrapper {
    height: 100%;
  }

  :deep(.gia-photo) {
    position: absolute;
    max-width: 42px;
    right: 12px;
    bottom: 12px;
  }
  :deep(.def-labels) {
    position: absolute;
    left: 12px;
    top: 12px;
  }

  :deep(.def-price-old) {
    @include point-md {
      margin-left: 8px;
    }
  }

  :deep(.def-img) {
    margin: 0 auto;
    width: auto;
  }
}
.slider-card-prices {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  @include point-md {
    flex-direction: row;
    justify-content: center;
  }
  :deep(.def-price-old) {
    display: inline-block;
    margin-bottom: 4px;
    @include point-md {
      margin-bottom: 0;
    }
  }
}
</style>
